import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as STATUS from 'constants/status';
import { sessionService } from 'redux-react-session';
import Avatar from 'components/Avatar';
import history from 'store/history';
import apiFetch from 'utils/apiFetch';
import {
  TAB_RESUME, TAB_ERASE, TAB_DATA, TAB_GPDR,
} from 'constants/profile';
import {
  ROUTE_DELETE_ACCOUNT_SUCCESS, ROUTE_LOGOUT, ROUTE_EDIT_PROFILE,
} from 'constants/urls';
import _ from 'lodash';
import { getUserData } from 'modules/users/actions';
import NoUserInfoImg from 'assets/images/think/no_think_chats.svg';
import CallIcon from 'assets/images/icons/impact_event.svg';
import TableIcon from 'assets/images/icons/table_gray.svg';
import Erase from 'assets/images/user/erase.svg';
import { getUserAnswers } from '../modules/actions';
import {
  ProfileWrapper, EraseForm, EraseButton, EraseText, Level, LevelSelector,
  EraseSubtext, TabContent, GPDRWrapper, LogoutButton, UserCardWrapper,
  ErasePop, Overlay, EraseButtonPop, EraseSubtextPop, NoElements,
} from './styles';

class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabSelected: TAB_RESUME,
      answers: null,
      profilePrivacyField: '',
      profilePrivacyElement: null,
      profilePrivacyLevel: 0,
      eraseForm: {
        errors: [],
        password: '',
        isSubmit: false,
      },
      erasePop: false,
      collapsed: false,
      data: null,
    };
  }

  componentDidMount() {
    const { resetAll } = this.props;
    resetAll();

    this.setBreadcrumbProfile();

    sessionService.loadUser()
      .then(({ id }) => {
        getUserData(id)
          .then((userData) => {
            this.setState({ data: userData });
          });

        getUserAnswers(id)
          .then((response) => {
            this.setState({ answers: response });
          });
      });
  }

  componentDidUpdate({ eraseAccountStatus: prevEraseAccountStatus }) {
    const { eraseAccountStatus } = this.props;

    if (eraseAccountStatus !== prevEraseAccountStatus && eraseAccountStatus === STATUS.STATUS_SUCCESS) {
      history.push(ROUTE_DELETE_ACCOUNT_SUCCESS);
    }
  }

  setBreadcrumbProfile = () => {
    const {
      literals, setBreadcrumb, resetContext,
    } = this.props;

    const breadcrumb = [
      {
        color: '#ffffff',
        text: literals.subtitle1,
      },
    ];
    setBreadcrumb(breadcrumb.slice());
    resetContext();
  };

  goToGpdr = () => {
    this.setState({ tabSelected: TAB_GPDR, erasePop: false });
  }

  handleLogout = () => {
    history.push(ROUTE_LOGOUT);
  }

  collapseInfo = () => {
    const { collapsed } = this.state;
    if (collapsed) {
      this.setState({ collapsed: false });
    } else {
      this.setState({ collapsed: true });
    }
  };

  whichHeader = () => {
    const { literals } = this.props;
    const { data, collapsed } = this.state;
    if (collapsed) {
      return (
        <div className='overview_empty' onClick={this.collapseInfo}>
          {literals.viewPurpose}
        </div>
      );
    }
    return (
      <div className='overview'>
        {data.overview}
        <div className='overview-content'>
          <i className='fas fa-minus-circle close' onClick={this.collapseInfo} />
        </div>
      </div>
    );
  };

  goToEditProfile = () => {
    history.push(ROUTE_EDIT_PROFILE);
  }

  printHeader = () => {
    const { data, tabSelected } = this.state;
    const {
      id, firstname, lastname, avatar, overview,
    } = data;
    const { literals } = this.props;

    if (tabSelected !== TAB_ERASE && tabSelected !== TAB_GPDR) {
      return (
        <div className='header'>
          <div className='username'>{`${firstname} ${lastname}`}</div>
          <div className='avatar'>
            <Avatar id={id} firstname={firstname} avatar={avatar} size={84} />
            {overview ? this.whichHeader() : null}
          </div>
          <div className='form'>
            <div className='form_buttons'>
              <button className='primary' onClick={this.goToEditProfile}>{literals.editProfile}</button>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  printResumeTab = () => {
    const {
      literals, userElements, userThemeTables,
    } = this.props;
    const { data } = this.state;

    const elementsRows = [];
    const elementTypesData = {};
    const elementTypes = [];
    _.forEach(userElements, (element) => {
      if (typeof elementTypesData[element.type] === 'undefined') {
        elementTypesData[element.type] = {
          name: element.type_name,
          elements: [],
        };

        elementTypesData[element.type].elements.push(element);
      }
    });

    _.forEach(elementTypesData, (elementType) => {
      elementTypes.push(elementType);
    });

    elementTypes.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });

    _.forEach(elementTypes, (elementType) => {
      elementsRows.push(
        <div>
          <div className='separator'>
            {elementType.name}
          </div>
          <div className='subsection_content'>
            {_.map(elementType.elements, ({ id, name }) => (
              <div key={id} className='tag gray selected'>
                {name}
              </div>
            ))}
          </div>
        </div>,
      );
    });

    if (!data.calls_for_impact.length && !data.theme_tables.length && !elementsRows.length) {
      return (
        <NoElements>
          <div className='nocontent'>
            <img src={NoUserInfoImg} alt='' />
            <div className='text'>{literals.noContent}</div>
            <div className='text'>{literals.noContentSub}</div>
          </div>
        </NoElements>
      );
    }
    return (
      <div>
        {data.calls_for_impact.length ? (
          <div>
            <div className='separator'>
              <img src={CallIcon} alt='' />
              {literals.callForImpact}
            </div>
            <div className='subsection_content'>
              {_.map(data.calls_for_impact, ({ id, name, image }) => (
                <div key={id} className='tag gray selected'>
                  {image ? (<div className='image' style={{ backgroundImage: `url(${image})` }} />) : null}
                  {name}
                </div>
              ))}
            </div>
          </div>
        ) : null}
        {data.theme_tables.length ? (
          <div>
            <div className='separator'>
              <img src={TableIcon} alt='' />
              {literals.otherPI}
            </div>
            <div className='subsection_content'>
              {_.map(data.theme_tables, ({ id, name }) => (
                <div
                  key={id}
                  className={`tag gray ${_.find(userThemeTables, { id }) ? 'selected' : ''}`}
                >
                  {name}
                </div>
              ))}
            </div>
          </div>
        ) : null}
        {elementsRows}
      </div>
    );
  };

  printUserCard = () => {
    return (
      <UserCardWrapper>
        <div className='tab_content'>{this.printResumeTab()}</div>
      </UserCardWrapper>
    );
  }

  printTabContent = () => {
    const { tabSelected } = this.state;

    switch (tabSelected) {
      case TAB_GPDR:
        return this.printGpdrTab();
      case TAB_ERASE:
        return this.printEraseTab();
      case TAB_DATA:
        return this.printRelations();
      default:
        return this.printUserCard();
    }
  }

  selectProfilePrivacyLevel = (event) => {
    const level = parseInt(event.target.getAttribute('data-level'), 10);
    const { profilePrivacyField, profilePrivacy, answers } = this.state;

    const pieces = profilePrivacyField.split('-');
    if (pieces[0] === 'question') {
      const narrativeType = pieces[1];
      const stepId = parseInt(pieces[2], 10);
      _.forEach(answers, (narrative) => {
        const question = _.find(narrative.questions, { id: stepId });
        if (question) {
          const newAnswers = [];
          _.forEach(question.answers, (answer) => {
            const newAnswer = Object.assign({}, answer);
            if (newAnswers.privacity !== level) {
              newAnswer.privacity = level;
            }
            newAnswers.push(newAnswer);
          });
          question.answers = newAnswers;
        }
      });
      const params = {
        level,
        narrative_type: narrativeType,
        step_id: stepId,
      };

      apiFetch('POST', { endPoint: 'elements/privacy' }, params);
    } else {
      profilePrivacy[profilePrivacyField] = level;
      const params = {
        level,
        field: profilePrivacyField,
      };

      apiFetch('POST', { endPoint: 'users/profile-field/privacy' }, params);
    }

    this.setState({ answers, profilePrivacy, profilePrivacyElement: null });
  }

  printProfileLevelSelector = () => {
    const {
      profilePrivacyLevel: level,
      profilePrivacyElement,
    } = this.state;
    const { app: { color1: color }, literals } = this.props;

    const clientRect = profilePrivacyElement.getBoundingClientRect();
    const top = clientRect.top - 50 + window.scrollY;
    const left = 20;
    return (
      <LevelSelector top={top} left={left}>
        <Level color={color} selected={level === 0} data-level='0' onClick={this.selectProfilePrivacyLevel}>
          <i className='fa fa-wifi' />
          {literals.visibleForAll}
        </Level>
        <Level color={color} selected={level === 1} data-level='1' onClick={this.selectProfilePrivacyLevel}>
          <i className='fa fa-user-shield' />
          {literals.shareInC2i}
        </Level>
        <Level color={color} selected={level === 2} data-level='2' onClick={this.selectProfilePrivacyLevel}>
          <i className='fa fa-comments' />
          {literals.shareWithUsersConnected}
        </Level>
        <Level color={color} selected={level === 3} data-level='3' onClick={this.selectProfilePrivacyLevel}>
          <i className='fa fa-lock' />
          {literals.private}
        </Level>
      </LevelSelector>
    );
  }

  printErasePop = () => {
    const { literals } = this.props;
    if (!this.state.erasePop) {
      return null;
    }
    return (
      <React.Fragment>
        <Overlay />
        <ErasePop>
          <div className='close_button'>
            <i className='far fa-times-circle close_icon' onClick={this.showErasePop} />
          </div>
          <EraseButtonPop onClick={this.showErasePop}>{literals.nuclearOption}</EraseButtonPop>
          <EraseSubtextPop>{literals.easeAllDataSub}</EraseSubtextPop>
          <button className='primary btn-sm claim' onClick={this.goToGpdr}>{literals.wantDelete}</button>
          <button className='primary btn-sm claim white'>{literals.cancel}</button>
        </ErasePop>
      </React.Fragment>
    );
  };

  showErasePop = () => {
    if (this.state.erasePop) {
      this.setState({ erasePop: false });
    } else {
      this.setState({ erasePop: true });
    }
  }

  printEraseTab = () => {
    const { literals } = this.props;
    return (
      <EraseForm>
        <EraseText>{literals.eraseAllData}</EraseText>
        <img src={Erase} alt='' />
        <EraseButton onClick={this.showErasePop}>{literals.nuclearOption}</EraseButton>
        <EraseSubtext>{literals.easeAllDataSub}</EraseSubtext>
        {this.printErasePop()}
      </EraseForm>
    );
  }

  printGpdrTab = () => {
    const { literals, eraseAccountError } = this.props;
    const {
      eraseForm: {
        errors, password, isSubmit,
      },
    } = this.state;

    return (
      <GPDRWrapper>
        <div className='notice'>{literals.gpdrNotice}</div>
        <div className='form'>
          <div className='form_question_title'>
            {literals.password}
            <span className='form_icon_required'> *</span>
          </div>
          <div className='form_question_input'>
            <input type='password' className={`form_input_stl ${_.find(errors, error => error === 'password') ? 'error' : ''}`} value={password} onChange={this.handleChangeErasePassword} />
          </div>
          {isSubmit && eraseAccountError ? (
            <div className='error_msg'>{eraseAccountError}</div>
          ) : null}
          <div className='form_buttons'>
            <button className='primary' onClick={this.handleSubmitErase}>{literals.accept}</button>
            <button className='cancel' onClick={this.handleViewErase}>{literals.cancel}</button>
          </div>
        </div>
      </GPDRWrapper>
    );
  }

  handleClickProfilePrivacy = (event) => {
    this.setState({
      profilePrivacyField: event.target.getAttribute('data-field'),
      profilePrivacyLevel: parseInt(event.target.getAttribute('data-level'), 10),
      profilePrivacyElement: event.target,
    });

    event.stopPropagation();
  }

  handleSubmitErase = () => {
    const { deleteAccount } = this.props;
    const { eraseForm } = this.state;
    const { errors, password } = eraseForm;

    // Clear array
    errors.splice(0, errors.length);

    let error = false;
    if (!password) {
      error = true;
      errors.push('password');
    }

    this.setState({ eraseForm });

    if (!error) {
      eraseForm.isSubmit = true;
      this.setState({ eraseForm });
      deleteAccount(password);
    }
  }

  handleChangeErasePassword = (event) => {
    const { value } = event.target;
    const { eraseForm } = this.state;

    eraseForm.password = value;

    this.setState({ eraseForm });
  }

  printRelations = () => {
    const { literals } = this.props;
    const {
      answers, profilePrivacyElement,
    } = this.state;
    let narrativesCount = 0;

    const narratives = _.map(answers, (narrative) => {
      let questionsCount = 0;
      const questions = _.map(narrative.steps, (step) => {
        if (!step.answers.length) {
          return null;
        }
        questionsCount += 1;

        const answersElements = _.map(step.answers, ({ id, name }) => (
          <div
            key={id}
            className='tag gray selected'
          >
            {name}
          </div>
        ));
        return (
          <div key={narrative.id}>
            <div className='step_name' dangerouslySetInnerHTML={{ __html: step.title }} />
            <div className='subsection_content'>{answersElements}</div>
          </div>
        );
      });

      if (!questionsCount) {
        return null;
      }

      narrativesCount += 1;
      return (
        <div key={narrative.id}>
          <div className='separator'>
            {narrative.name}
          </div>
          {questions}
        </div>
      );
    });

    if (!narrativesCount) {
      return (
        <NoElements>
          <div className='nocontent'>
            <img src={NoUserInfoImg} alt='' />
            <div className='text'>{literals.noContent}</div>
            <div className='text'>{literals.noContentSub}</div>
          </div>
        </NoElements>);
    }

    return (
      <div className='tab_content'>
        {profilePrivacyElement && this.printProfileLevelSelector()}
        {narratives}
      </div>
    );
  };

  handleViewResume = () => {
    this.setState({ tabSelected: TAB_RESUME });
  }

  handleViewErase = () => {
    this.setState({ tabSelected: TAB_ERASE });
  }

  handleViewData = () => {
    this.setState({ tabSelected: TAB_DATA });
  }

  render() {
    const { literals } = this.props;
    const { tabSelected, data, answers } = this.state;

    if (!data || !answers) {
      return (
        <ProfileWrapper className='Profile'>
          <div className='loading'>
            <div className='text'>{literals.loading}</div>
          </div>
        </ProfileWrapper>
      );
    }

    return (
      <ProfileWrapper className='Profile'>
        <div className='titles_profile'>
          <LogoutButton onClick={this.handleLogout}>{literals.logout}</LogoutButton>
        </div>
        <UserCardWrapper>
          <div>
            {this.printHeader()}
            <div className='tabs inline'>
              <div className={`tab ${tabSelected === TAB_RESUME ? 'selected' : ''}`} onClick={this.handleViewResume}>
                {literals.resume}
              </div>
              <div className={`tab ${tabSelected === TAB_DATA ? 'selected' : ''}`} onClick={this.handleViewData}>
                {literals.data}
              </div>
              <div className={`tab ${tabSelected === TAB_ERASE || tabSelected === TAB_GPDR ? 'selected' : ''}`} onClick={this.handleViewErase}>
                {literals.erase}
              </div>
            </div>
            <TabContent>
              {this.printTabContent()}
            </TabContent>
          </div>
        </UserCardWrapper>
      </ProfileWrapper>
    );
  }
}

Profile.propTypes = {
  resetAll: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  resetContext: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired,
  eraseAccountError: PropTypes.string,
  eraseAccountStatus: PropTypes.string,
};

Profile.defaultProps = {
  eraseAccountError: null,
  eraseAccountStatus: null,
};

export default Profile;



// WEBPACK FOOTER //
// ./src/routes/Profile/components/index.jsx